// extracted by mini-css-extract-plugin
export default {"buttons":"styles_buttons__yHF4x","button":"styles_button__H3451"};